module.exports = __webpack_public_path__ + "static/media/2.56898eb3.png";